import { apiClient } from '../../services/api';

function safeParse(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw !== null ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

const state = () => ({
  pastas: null,
  cod_pasta: safeParse('@socialcam/cod_pasta', null),
  isPastaAtiva: safeParse('@socialcam/isPastaAtiva', false),
});

const getters = {
  getterPastas: state => {
    return state.pastas;
  },
  getterCodPasta: state => {
    return state.cod_pasta
  },
  getterIsPastaAtiva: state => {
    return state.isPastaAtiva
  }
};

const actions = {
  async getPastas({ commit }, payload) {
    const { cod_producao } = payload;
    try {
      const { data } = await apiClient.get(
        `/pastas/listarPastas/${cod_producao}`
      );

      commit('setPastas', data.pastas);

      return data.pastas
    } catch (error) {
      return error;
    }
  },
}

const mutations = {
  setPastas(state, payload) {
    state.pastas = payload;
  },
  setCodPasta(state, payload) {
    state.cod_pasta = payload
  },
  setIsPastaAtiva(state, payload) {
    state.isPastaAtiva = payload
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};